import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import SelectSellOrderTypeModalContent from './SelectSellOrderTypeModalContent';
export const SelectSellOrderTypeModal = {
    show: (symbol, assetId, onSelectOrderType) => {
        Modal.show(<SelectSellOrderTypeModalContent symbol={symbol} assetId={assetId} closeModal={Modal.hide} onSelectOrderType={onSelectOrderType}/>, {
            title: 'Order type',
            containerStyle: styles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
